import { Component, Input } from '@angular/core';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { MasterHelper } from 'src/app/core/utilities';
import { SelfassementSummary } from 'src/app/core/models/self-assessmentT3/SelfassessmentSummary';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { ActivatedRoute } from '@angular/router';
import { ChangeDetailComponent } from '../../change-detail/change-detail.component';

@Component({
  selector: 'app-summary-t3',
  templateUrl: './summary-t3.component.html',
  styleUrls: ['./summary-t3.component.scss']
})
export class SummaryT3Component {
selftassessmentSummary:SelfassementSummary;
effectiveDate: string;
isLoading:boolean=true;
@Input() selfAssessmentId:number;
@Input() selfassessmentSummaryFromParent:SelfassementSummary;
constructor(
  private route: ActivatedRoute,
  public dialog: MatDialog,
  private selfAssessment3Service: SelfAssessmentTemplate3Service,
)
{
  this.selftassessmentSummary = new SelfassementSummary();
  this.effectiveDate = '';
  this.selfAssessmentId = 0;
  this.selfassessmentSummaryFromParent = new SelfassementSummary();
}
ngOnInit() {
  if (this.selfAssessmentId == 0) {
    this.selfAssessmentId = Number(this.route.snapshot.params['id']);
  }

  this.getSelfassessmentSummary(this.selfAssessmentId);
  this.isLoading= false;
}
openView(id: number, detailType: number) {
  const dialogRef = this.dialog.open(ChangeDetailComponent, {
    width: '1800px',
    height: '870px',
    data: {
      id: id,
      detailType: detailType,
      ruleArr: null,
      filterType: 'All',
      type: 'modal',
    },
  });
  dialogRef.afterClosed().subscribe((result: any) => {
    // this.ruleBookViewCloseData = result;
    // if (result) {
    //   const index = this.ruleBooks.data.findIndex(
    //     (item) => item.id === result.Id
    //   );
    //   if (index !== -1) {
    //     this.ruleBooks.data[index].applicable = result.IsApplicable;
    //     this.ruleBooks.data[index].operative = result.IsOperative;
    //     this.ruleBooks.data[index].isRead = result.IsRead;
    //     this.ruleBooks.data[index].owner = result.ownerList;
    //   }
    // }
    // this.sessionService.isLibraryTabActive = false;
  });
}

getSelfassessmentSummary(id:number){

  this.selfAssessment3Service.getT3SummaryAssessment(id).subscribe((data:any)=>{

    this.selftassessmentSummary= data;
    // this.effectiveDate = this.dateFormat(data.effectiveDate);
  })
}
// dateFormat(effectiveDate: string): any {
//   const eDate = effectiveDate
//     ? effectiveDate.split('|')[0]
//     : MasterHelper.getDateStr(0);
//   return MasterHelper.formatDate(eDate, 'YYYY-MM-DD');
// }
}
